import { InjectionToken } from '@angular/core';
import OpenAI from 'openai';

export const OPENAI_CLIENT: InjectionToken<OpenAI> = new InjectionToken<OpenAI>('OpenAI API client instance');
